import { PaginationInfo } from '../models/pagination-info';

/**
 * Map to pagination info.
 * @param {object} dto Dto.
 * @param {Function} modelMapper Callback to map model.
 * @returns {PaginationInfo}
 */
function fromDto(dto, modelMapper) {
  return new PaginationInfo({
    count: dto.meta.pagination.count,
    currentPage: dto.meta.pagination.current_page,
    totalPages: dto.meta.pagination.total_pages,
    nextPage: dto.meta.pagination.links.next ?? null,
    previousPage: dto.meta.pagination.links.previous ?? null,
    total: dto.meta.pagination.total,
    data: dto.data.map(item => modelMapper(item)),
  });
}

export const paginationInfoMapper = {
  fromDto,
};
